export default {
  getFilterUrl (state) {
    return state.listFilters && Array.isArray(state.listFilters)
      ? state.listFilters.join(',')
      : [];
  },
};
